export const config = {
    firebaseConfig : {
        apiKey: "AIzaSyBe5x60ajBSDII2IeImksx7vKaI3Ty-krQ",
        authDomain: "simple-notes-a4c82.firebaseapp.com",
        projectId: "simple-notes-a4c82",
        storageBucket: "simple-notes-a4c82.appspot.com",
        messagingSenderId: "502065041942",
        appId: "1:502065041942:web:1854bb9a17ccf425df1b37",
        measurementId: "G-N6HCSKRBQ2"
    },
    colors: {
        black: {
            black0: '#2b2d42',
            black10: '#27293b',
            black20: '#222435',
            black30: '#1e1f2e',
            black40: '#1a1b28',
            black50: '#161721',
            black60: '#11121a',
            black70: '#0d0d14',
            black80: '#09090d',
            black90: '#040407',
        },
        white: '#edf2f4',

        red: '#d90429'
    }
}
